<template>
    <CampaignCouponList />
</template>

<script>
import CampaignCouponList from "@/components/CampaignCouponList.vue";

export default {
    name: "CampaignCouponListView",
    components: {
        CampaignCouponList,
    },
};
</script>